import React, { useState, useRef, useEffect } from "react";
import PricingCard from "../../molecules/PricingCard/PricingCard";
import { useTranslation } from "react-i18next";

interface PricingProps {
  currentPlan?: string;
}

const Pricing: React.FC<PricingProps> = (props) => {
  const { currentPlan } = props;

  const { t } = useTranslation();

  const pricingPlans = [
    {
      title: t("standard"),
      tier: "standard",
      price: 20,
      features: [
        t("standardFeature1"),
        t("standardFeature2"),
        t("standardFeature3"),
        t("standardFeature4"),
      ],
    },
    {
      title: t("premium"),
      tier: "premium",
      price: 30,
      features: [
        t("premiumFeature1"),
        t("premiumFeature2"),
        t("premiumFeature3"),
        t("premiumFeature4"),
      ],
      isPopular: currentPlan === undefined && true,
    },
    // TODO: Uncomment when pro is ready AND ADD I18N
    // {
    //   title: "Pro",
    //   tier: "pro",
    //   price: 35,
    //   features: [
    //     "Všetky PREMIUM funkcie",
    //     "Využitie umelej inteligencie",
    //     "Inteligentné formátovanie",
    //     "AI asistent pri vyšetrovaní",
    //   ],
    // },
  ];

  const [activeSlide, setActiveSlide] = useState(1); // Start with the middle card active
  const cardsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (cardsRef.current && window.innerWidth <= 768) {
        const scrollPosition = cardsRef.current.scrollLeft;
        const slideWidth = cardsRef.current.offsetWidth;
        const newActiveSlide = Math.round(scrollPosition / slideWidth);
        setActiveSlide(newActiveSlide);
      }
    };

    const cardsElement = cardsRef.current;
    if (cardsElement) {
      cardsElement.addEventListener("scroll", handleScroll, { passive: true });

      if (window.innerWidth <= 768) {
        setTimeout(() => {
          scrollToSlide(1);
        }, 100);
      }
    }

    return () => {
      if (cardsElement) {
        cardsElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollToSlide = (index: number) => {
    if (cardsRef.current) {
      const slideWidth = cardsRef.current.offsetWidth;
      cardsRef.current.scrollTo({
        left: index * slideWidth,
        behavior: "smooth",
      });
      setActiveSlide(index);
    }
  };

  return (
    <div className="dui-pricing" id="pricing">
      <div className="dui-pricing-container">
        <div className="dui-pricing-cards" ref={cardsRef}>
          {pricingPlans.map((plan, index) => (
            <PricingCard
              key={index}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              isPopular={plan.isPopular}
              tier={plan.tier}
              active={plan.tier === currentPlan}
            />
          ))}
        </div>

        <ul className="carousel-indicators">
          {pricingPlans.map((_, index) => (
            <li
              key={index}
              className={index === activeSlide ? "active" : ""}
              onClick={() => scrollToSlide(index)}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Pricing;
